import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import Button from "react-bootstrap/Button";


import FldCloseIcon from "../images/round-close-icon.svg";

import ValidationAlertIcon from "../images/validation-alert-icon.svg";
import ConfettiColoredIcon from "../images/confetti-colored-icon.svg";

const ProfileSetupFirst = () => {
 


  return (
    <div className="mobile-wrapper bg-grey-variant">

      <div className="mobile-wrapper-inner bg-grey-variant">
      
      <div className="signup-login-header clearfix">
        
          <div className="confetti-colored-icon mt-2 mx-auto">
          <img src={ConfettiColoredIcon} />
          </div>
          <h2 className="pt-2 pb-2 text-center">Let’s create your profile!</h2>
          <p className="text-center mb-18">We’re here to help meet you and your client’s real estate goals. Let’s set up your profile.</p>
          
        </div>
        <div className="title-selection-wrap ">
          <p className="mb-3">What’s your current title?</p>
          
          <a href="#" className="title-selection-innner mb-3">
            Real Estate Agent

          </a>

          <a href="#" className="title-selection-innner mb-3">
          Property Manager

          </a>

          <a href="#" className="title-selection-innner mb-4">
          Both

          </a>
        
        
        
        
        </div>

        <Button variant="primary" className="btn w-100 mb-4" disabled>Continue</Button>

        

        

        
        
        
        
        
                       
        
      </div>
    </div>
  );
};

export default ProfileSetupFirst;
